import React from 'react';
import { Seed } from './Seed';
const coverage = [{
  label: 'Page A',
  body: 'The plan, the arrival script and the directive in five steps or fewer, with the words to say in italics'
}, {
  label: 'Reflect',
  body: '5 or 6 processing questions already written, from the image to meaning, without interpreting the art'
}, {
  label: 'Close',
  body: 'A closing ritual, containment, and a session-note line with blanks to fill in'
}, {
  label: 'Every format',
  body: 'Easier, group and online adaptations, plus an age note for kids, teens and adults'
}, {
  label: 'Page C',
  body: 'A printable worksheet for every session, 64 in total, initials only'
}, {
  label: 'Intensity',
  body: 'Every session marked Gentle, Moderate or Deep, so you know what fits your training'
}];
const steps = [{
  name: 'Arrive',
  time: '5 min',
  tone: 'bg-teal-soft text-teal-deep'
}, {
  name: 'Create',
  time: '15–25 min',
  tone: 'bg-lav-soft text-lav-deep'
}, {
  name: 'Reflect',
  time: '10 min',
  tone: 'bg-peach-soft text-peach-deep'
}, {
  name: 'Close',
  time: '5 min',
  tone: 'bg-sage-soft text-sage-deep'
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="relative w-full overflow-hidden bg-white" data-id="element-261" data-mp="1f0zqv9p5p0pm">
      <Seed className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 opacity-40" data-id="element-262" data-mp="1ju183ocu5ccd" />
      <div className="relative mx-auto max-w-5xl px-5 py-16 text-center sm:py-20" data-id="element-263" data-mp="1orudwga884c4">
        <p className="text-sm font-semibold text-teal-deep" data-id="element-264" data-mp="s3emeenk3kwd">The mechanism</p>
        <h2 id="mechanism-heading" className="mt-3 font-display text-3xl font-semibold text-navy sm:text-5xl" data-id="element-265" data-mp="w35b8ctivqy9">
          The 4-Step Session Arc
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-navy-soft sm:text-lg" data-id="element-266" data-mp="114um9sgqw4mc">
          Every one of the 52 sessions follows the same arc, so you always know
          where you are in the hour. And the part most resources skip, the{' '}
          <span className="font-semibold text-navy" data-id="element-267" data-mp="2hg8cax5892o7">questions to ask once the art is done</span>,
          is written for you in every session.
        </p>

        <ol className="mx-auto mt-9 grid max-w-3xl grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-268" data-mp="1ruyrlf3n3uun">
          {steps.map((step, i) => <li key={step.name} className={`rounded-2xl px-4 py-4 ${step.tone}`} data-id="element-269" data-mp="21qs26sxste9s" data-mpi={i}>
              <span className="block font-display text-sm font-medium opacity-70" data-id="element-270" data-mp="21opcyb4gzp64">Step {i + 1}</span>
              <span className="mt-1 block font-display text-xl font-semibold" data-id="element-271" data-mp="192e4keamgjyr">{step.name}</span>
              <span className="mt-0.5 block text-xs font-semibold opacity-80" data-id="element-272" data-mp="1901ne3coudmr">{step.time}</span>
            </li>)}
        </ol>

        <ul className="mt-9 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-273" data-mp="1isfs94z2c0d5">
          {coverage.map(item => <li key={item.label} className="rounded-2xl bg-paper px-4 py-3.5 ring-1 ring-paper-dark" data-id="element-274" data-mp="1e0phixw7ral7">
              <span className="block text-xs font-bold text-teal-deep" data-id="element-275" data-mp="qabvbo0b85yj">{item.label}</span>
              <span className="mt-1 block text-sm text-navy" data-id="element-276" data-mp="lc0l3c63rtfs">{item.body}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}